import { useEffect } from 'react';
import { prop, pick } from 'ramda';
import { useGetRGConfiguration } from 'server';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';
import { useAppSelector, useUserSelector, useAuthSelector } from 'js/store/hooks';
import { RG_CONFIGURATION_TYPE } from 'js/hooks/socket/hooks/useGetRGConfiguration/constants';

import * as actions from '../../../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../../store';

export const useLimitsSettings = () => {
    const dispatch = useDynamicReducerDispatch();
    const casino = useAppSelector(prop('casinoName'));
    const getRGConfiguration = useGetRGConfiguration();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isLogoutInProcess = useAuthSelector(prop('isLogoutInProcess'));
    const { fields, limitsCurrency } = useDynamicReducerSelector(pick(['fields', 'limitsCurrency']));
    const betLimitsField = fields.find(field => field.type === FORM_FIELD_TYPE.BET_LIMITS);
    const lossLimitsField = fields.find(field => field.type === FORM_FIELD_TYPE.LOSS_LIMITS);

    useEffect(() => {
        if (isLoggedIn || isLogoutInProcess || !limitsCurrency) {
            return;
        }

        if (betLimitsField?.active || lossLimitsField?.active) {
            const type = [
                lossLimitsField?.active && RG_CONFIGURATION_TYPE.LOSS_LIMIT,
                betLimitsField?.active && RG_CONFIGURATION_TYPE.BET_LIMIT
            ].filter(Boolean) as RG_CONFIGURATION_TYPE[];

            (async () => {
                const { betLimitConfigurationItems = [], lossLimitConfigurationItems = [] } = await getRGConfiguration({
                    type,
                    casino,
                    currencyCode: limitsCurrency
                });

                dispatch(actions.setLimitsSettings('bet', betLimitConfigurationItems[0]));
                dispatch(actions.setLimitsSettings('loss', lossLimitConfigurationItems[0]));
            })();
        }
    }, [
        isLoggedIn, isLogoutInProcess,
        limitsCurrency, dispatch,
        casino, getRGConfiguration,
        betLimitsField, lossLimitsField
    ]);
};
